import { View, Text } from '@react-pdf/renderer';
import styles from '../styles/styles';

interface MeasurementsProps {
    labels: {
        header: string;
        section: string;
        front: string;
        back?: string;
        correction: string;
        middleValues: string;
        height: string;
        length: string;
        solidPercentage: string;
        supportCount?: string;
        rejectCount?: string;
    };
    data: {
        measurements: {
            section: number | string;
            front: string;
            back?: string;
        }[];
        solidInputs?: Record<string, string>;
        solidInputLabels?: Record<string, string>;
        avgHeight: string;
        avgLength: string;
        solidPercentage: string;
        countSupports?: string;
        countRejects?: string;
    };
}

const Measurements = ({ labels, data }: MeasurementsProps) => {
    const solidKeys = data.solidInputs ? Object.keys(data.solidInputs) : [];
    const maxRows = Math.max(data.measurements.length, solidKeys.length);
    const hasBackMeasurements = data.measurements?.some(m => m?.back);

    return (
        <>
            <View style={styles.row}>
                <Text style={styles.subHeader}>{labels.header}</Text>
            </View>
            <View style={styles.miniSpacer} />

            {/* Table Header */}
            <View style={styles.tableRow}>
                <View style={styles.tableCol}><Text style={styles.label}>{labels.section}:</Text></View>
                <View style={styles.tableCol}><Text style={styles.label}>{labels.front}:</Text></View>
                <View style={styles.tableCol}><Text style={styles.label}>{hasBackMeasurements ? `${labels.back}:` : ''}</Text></View>
                <View style={styles.tableCol}><Text style={styles.label}>{data.solidInputs && data.solidInputLabels ? `${labels.correction}:` : ''}</Text></View>
                <View style={styles.tableCol}></View>
            </View>

            {/* Rows */}
            {[...Array(maxRows)].map((_, idx) => {
                const height = data.measurements[idx];
                const key = solidKeys[idx];
                const label = key && data.solidInputLabels ? data.solidInputLabels[key] : '';

                return (
                    <View key={`m-${idx}`} style={styles.tableRow}>
                        <View style={styles.tableCol}><Text>{height?.section ?? ''}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.alignText}>{height?.front ?? ''}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.alignText}>{height?.back ?? ''}</Text></View>
                        <View style={styles.tableCol}><Text>{label}</Text></View>
                        <View style={styles.tableCol}><Text style={styles.alignText}>{key && data.solidInputs ? data.solidInputs[key] : ''}</Text></View>
                    </View>
                );
            })}

            {/* Values */}
            {data.measurements.length >= solidKeys.length && <View style={styles.tableRow}><View style={styles.spacer} /></View>}
            <View style={styles.tableRow}>
                <View style={styles.tableCol}><Text style={styles.label}>{labels.middleValues}:</Text></View>
                <View style={styles.tableCol} />
                <View style={styles.tableCol} />
                <View style={styles.tableCol} />
                <View style={styles.tableCol} />
            </View>

            <View style={styles.tableRow}>
                <View style={styles.tableCol}><Text>{labels.height}</Text></View>
                <View style={styles.tableCol}><Text>{data.avgHeight}</Text></View>
                <View style={styles.tableCol} />
                <View style={styles.tableCol}><Text style={styles.label}>{labels.solidPercentage}:</Text></View>
                <View style={styles.tableCol} />
            </View>

            <View style={styles.tableRow}>
                <View style={styles.tableCol}><Text>{labels.length}</Text></View>
                <View style={styles.tableCol}><Text>{data.avgLength}</Text></View>
                <View style={styles.tableCol} />
                <View style={styles.tableCol}><Text>{data.solidPercentage}</Text></View>
                <View style={styles.tableCol} />
            </View>

            {/* Supports & rejects */}
            {data.countSupports && data.countRejects && (
                <>
                    <View style={styles.spacer} />
                    <View style={styles.row}>
                        <View style={styles.column}>
                            <Text style={styles.label}>{labels.rejectCount}:</Text>
                            <Text>{data.countRejects}</Text>
                        </View>
                        <View style={styles.column}>
                            <Text style={styles.label}>{labels.supportCount}:</Text>
                            <Text>{data.countSupports}</Text>
                        </View>
                        <View style={styles.column} />
                        <View style={styles.column} />
                        <View style={styles.column} />
                    </View>
                </>
            )}
        </>
    );
};

export default Measurements;